<div class="system-logs">
  <h2>Audit</h2>

  <div class="system-logs__flex-div">
    <div class="system-logs__table">
      <div class="system-logs__export" *ngIf="tableData.length">
        <app-export [content]="exportData"></app-export>
      </div>
      <app-table
        *ngIf="tableData.length; else nodata"
        [content]="tableData"
        [headers]="auditAllHeaders"
        [tableType]="'system-logs'"
        (rowAction)="openValuesChanges($event)"
        (pageChanged)="onPageChange($event)"
        [countPagination]="countOfItems"
        [setFirstPage]="isDateChanged"
      ></app-table>
      <ng-template #nodata>
        There is no data for {{ selectedDate }}
      </ng-template>
    </div>
    <div class="system-logs__mange-board">
      <h3>Choose logs date</h3>
      <div class="system-logs__dropdown">
        <app-datepicker
          [label]="'Date'"
          [iconLeft]="true"
          [formControl]="date"
          [disableFutureDates]="true"
        ></app-datepicker>
      </div>
      <h3>Users</h3>
      <div *ngFor="let user of employeeNames" class="option-user">
        <label class="label-check">
          <input
            class="check_input"
            type="checkbox"
            [(ngModel)]="user.selected"
            (change)="handlingCheckboxesChanges()"
          />
          <span class="check_box"></span>
          {{ user.name }}
        </label>
      </div>
    </div>
  </div>
</div>
